import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while trying to download a license or software bundle for an expired product.
 */
export class ProductExpiredError extends RESTError {}
